import React from 'react'
import { connect } from 'react-redux'
import {postLogin, postFacebookLogin} from '../../../../redux/modules/session'
import {showModal} from '../../../../redux/modules/modal'
import {UniLink} from '../../unilink/index'
import {SecondaryButton} from '../../unilink/index'
import {TextInput} from '../../input/index'
import asModal from '../AsModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './loginAndRegisterForm.css'
import isFunction from 'lodash/isFunction'

class LoginForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: ''
    }

    this.updateEmail = this.updateEmail.bind(this)
    this.updatePassword = this.updatePassword.bind(this)
    this.formSubmit = this.formSubmit.bind(this)
  }
  updateEmail(e) {
    this.setState({email:e.target.value})
  }
  updatePassword(e) {
    this.setState({password:e.target.value})
  }
  formSubmit(e) {
    e.preventDefault()
    const {postLogin, followUp} = this.props
    const {email, password} = this.state
    postLogin(email,password)
    if (followUp && isFunction(followUp)) {
      followUp()
    }
  }
  render() {
    const {postFacebookLogin, switchToRegister, switchToForgotPassword, className} = this.props
    const classNames = ['loginAndRegister-form', className]
    return (
      <div className={classNames.join(' ')}>
        <div className='loginAndRegister-form__title'>
          <h1>Sign in</h1>
          <span className='loginAndRegister-form__no-account'>
            Don't have an account yet?
            <UniLink
              className='loginAndRegister-form__link'
              onClick={switchToRegister}
            >
              Sign up
            </UniLink>
          </span>
        </div>
        <form
          onSubmit={this.formSubmit}
          className='loginAndRegister-form__form'>
          <div className='loginAndRegister-form__text-inputs'>
            <TextInput
              className='loginAndRegister-form__text'
              onChange={this.updateEmail}
              value={this.state.email}
              placeholder="Email"
            />
            <TextInput
              className='loginAndRegister-form__text'
              onChange={this.updatePassword}
              value={this.state.password}
              placeholder="Password"
              type="password"
            />
          </div>
          <div className='loginAndRegister-form__buttons'>
            <UniLink className='loginAndRegister-form__link' onClick={switchToForgotPassword}>
              Forgot your password?
            </UniLink>
            <SecondaryButton
              disabled={!(this.state.email.trim() 
                && this.state.password.trim())}
              type='submit'>
              Log in
            </SecondaryButton>
          </div>
        </form>
        <div className='loginAndRegister-form__or' />
        <SecondaryButton
          onClick={postFacebookLogin}
          className='loginAndRegister-form__facebook'>
          <FontAwesomeIcon icon={['fab', 'facebook-square']} /> Log in with Facebook
        </SecondaryButton>
        <div className='loginAndRegister-form__disclaimer'>
          <span >
            By clicking sign up, you are confirming that you are 13 or older and you are agreeing to Expii's Terms of Service and Privacy Policy.
          </span>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => (
  {
    postLogin: (email, password) => {
      if (!password.trim() || !email.trim()) {
        return
      }
      dispatch(postLogin({'email':email,'password_raw':password}))
    },
    postFacebookLogin: () => {
      dispatch(postFacebookLogin())
    },
    switchToRegister: () => {
      dispatch(showModal('REGISTER', {}))
    },
    switchToForgotPassword: () => {
      dispatch(showModal('FORGOT_PASSWORD', {}))
    }
  }
)
export const VisibleLoginForm = connect(
  null,
  mapDispatchToProps
)(LoginForm)
const LoginFormModal = asModal(VisibleLoginForm, 'Log In')
export default LoginFormModal



// WEBPACK FOOTER //
// ./src/core/components/modals/login-and-register/LoginForm.js